var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "calendar-event-edit" },
    [
      _c("w-input", {
        attrs: {
          lg: "",
          autofocus: "",
          placeholder: _vm.$ct("labels.title-placeholder"),
        },
        model: {
          value: _vm.event.Title,
          callback: function ($$v) {
            _vm.$set(_vm.event, "Title", $$v)
          },
          expression: "event.Title",
        },
      }),
      _c(
        "w-form-section",
        { attrs: { label: _vm.$ct("labels.when"), stacked: "" } },
        [
          _c("w-switch", {
            attrs: { slot: "label-actions", label: _vm.$ct("labels.all-day") },
            slot: "label-actions",
            model: {
              value: _vm.event.AllDay,
              callback: function ($$v) {
                _vm.$set(_vm.event, "AllDay", $$v)
              },
              expression: "event.AllDay",
            },
          }),
          _c(
            "div",
            { staticClass: "when", class: { allDay: _vm.event.AllDay } },
            [
              _c("app-date-time-edit", {
                attrs: {
                  inline: "",
                  "label-date": _vm.$ct("labels.start"),
                  "label-time": _vm.$ct("labels.start-time"),
                  "hide-time-picker": _vm.event.AllDay,
                },
                model: {
                  value: _vm.event.StartTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.event, "StartTime", $$v)
                  },
                  expression: "event.StartTime",
                },
              }),
              _c("w-fa", {
                staticClass: "when-arrow",
                attrs: { icon: "arrow-right" },
              }),
              _c("app-date-time-edit", {
                attrs: {
                  inline: "",
                  "has-error": _vm.endTimeHasError,
                  "label-date": _vm.$ct("labels.end"),
                  "label-time": _vm.$ct("labels.end-time"),
                  "hide-time-picker": _vm.event.AllDay,
                },
                model: {
                  value: _vm.event.EndTime,
                  callback: function ($$v) {
                    _vm.$set(_vm.event, "EndTime", $$v)
                  },
                  expression: "event.EndTime",
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "when-duration",
              class: { error: _vm.endTimeHasError },
            },
            [
              _vm.endTimeHasError
                ? [_vm._v(_vm._s(_vm.$ct("duration.ends-before-start")))]
                : [
                    _vm._v(_vm._s(_vm.$ct("duration.lasts")) + " "),
                    _c("b", [_vm._v(_vm._s(_vm.durationText))]),
                  ],
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "two-col" },
        [
          _c(
            "w-form-section",
            { attrs: { label: _vm.$ct("calendar"), stacked: "" } },
            [
              _c("app-calendar-select", {
                model: {
                  value: _vm.event.CalendarID,
                  callback: function ($$v) {
                    _vm.$set(_vm.event, "CalendarID", $$v)
                  },
                  expression: "event.CalendarID",
                },
              }),
            ],
            1
          ),
          _c(
            "w-form-section",
            { attrs: { label: _vm.$ct("color"), stacked: "" } },
            [
              _c("w-select", {
                attrs: { items: _vm.getColorMethodItems },
                model: {
                  value: _vm.event.GetColorMethod,
                  callback: function ($$v) {
                    _vm.$set(_vm.event, "GetColorMethod", $$v)
                  },
                  expression: "event.GetColorMethod",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showColorPicker
        ? _c(
            "w-color-swatches",
            {
              staticClass: "swatches",
              attrs: { value: _vm.event.Color },
              on: {
                input: function ($event) {
                  _vm.event.Color = $event
                },
              },
            },
            [
              _c("app-color-picker", {
                attrs: { color: _vm.event.Color, compact: "" },
                on: {
                  input: function ($event) {
                    _vm.event.Color = $event
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-form-section",
        { attrs: { label: _vm.$ct("reminders.title"), stacked: "" } },
        [
          _c(
            "w-link",
            {
              staticClass: "label-link",
              attrs: { slot: "label-actions" },
              on: {
                click: function ($event) {
                  return _vm.addReminder()
                },
              },
              slot: "label-actions",
            },
            [
              _c("w-fa", { staticClass: "mrs", attrs: { icon: "plus" } }),
              _vm._v(_vm._s(_vm.$ct("reminders.add-short")) + " "),
            ],
            1
          ),
          _c("app-calendar-event-reminders", {
            attrs: {
              reminders: _vm.event.getOwnReminders(),
              "show-add": false,
            },
            on: {
              remove: function ($event) {
                return _vm.event.removeReminder($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-form-section",
        { attrs: { label: _vm.$ct("link.title"), stacked: "" } },
        [
          !_vm.sale && !_vm.linkingSale
            ? _c(
                "w-link",
                {
                  staticClass: "label-link",
                  attrs: { slot: "label-actions" },
                  on: {
                    click: function ($event) {
                      _vm.linkingSale = true
                    },
                  },
                  slot: "label-actions",
                },
                [
                  _c("w-fa", { staticClass: "mrs", attrs: { icon: "plus" } }),
                  _vm._v(_vm._s(_vm.$ct("link.add-sale")) + " "),
                ],
                1
              )
            : _vm._e(),
          _vm.sale
            ? _c(
                "w-record-card",
                {
                  attrs: {
                    icon: "file-invoice",
                    subtitle: _vm.saleSubtitle,
                    removable: "",
                    "remove-tooltip": _vm.$ct("link.remove"),
                  },
                  on: {
                    remove: function ($event) {
                      _vm.sale = null
                    },
                  },
                },
                [
                  _c("template", { slot: "title" }, [
                    _vm._v(" " + _vm._s(_vm.sale.ComputedFriendlyID) + " "),
                    _vm.sale.CompanyName
                      ? _c("span", { staticClass: "record-company" }, [
                          _vm._v(_vm._s(_vm.sale.CompanyName)),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "w-link",
                    {
                      attrs: { slot: "actions" },
                      on: {
                        click: function ($event) {
                          return _vm.openSale()
                        },
                      },
                      slot: "actions",
                    },
                    [
                      _c("w-fa", {
                        staticClass: "mrs",
                        attrs: { icon: "external-link-alt" },
                      }),
                      _vm._v(_vm._s(_vm.$ct("open-sale"))),
                    ],
                    1
                  ),
                  _c("w-switch", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.$ct("link.follows-delivery-date-hint"),
                        expression: "$ct('link.follows-delivery-date-hint')",
                      },
                    ],
                    attrs: {
                      slot: "footer",
                      space: "",
                      label: _vm.$ct("link.follows-delivery-date"),
                    },
                    slot: "footer",
                    model: {
                      value: _vm.event.StartTimeIsLinkedToSaleDeliveryDate,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.event,
                          "StartTimeIsLinkedToSaleDeliveryDate",
                          $$v
                        )
                      },
                      expression: "event.StartTimeIsLinkedToSaleDeliveryDate",
                    },
                  }),
                ],
                2
              )
            : _vm.linkingSale
            ? _c(
                "div",
                { staticClass: "link-search" },
                [
                  _c("app-sale-search", {
                    attrs: { placeholder: _vm.$ct("couple-with-sale") },
                    model: {
                      value: _vm.sale,
                      callback: function ($$v) {
                        _vm.sale = $$v
                      },
                      expression: "sale",
                    },
                  }),
                  _c("w-button", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.$t("common.cancel"),
                        expression: "$t('common.cancel')",
                      },
                    ],
                    attrs: { flat: "", round: "", icon: "times" },
                    on: {
                      click: function ($event) {
                        _vm.linkingSale = false
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.event.CrmID
            ? _c(
                "w-record-card",
                {
                  attrs: {
                    icon: "handshake",
                    title: _vm.$ct("link.crm-title", { id: _vm.event.CrmID }),
                    subtitle: _vm.crmSubtitle,
                  },
                },
                [
                  _c(
                    "w-link",
                    {
                      attrs: { slot: "actions" },
                      on: {
                        click: function ($event) {
                          return _vm.openCrm()
                        },
                      },
                      slot: "actions",
                    },
                    [
                      _c("w-fa", {
                        staticClass: "mrs",
                        attrs: { icon: "external-link-alt" },
                      }),
                      _vm._v(_vm._s(_vm.$ct("open-crm"))),
                    ],
                    1
                  ),
                  _c("w-switch", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.$ct("link.follows-crm-schedule-hint"),
                        expression: "$ct('link.follows-crm-schedule-hint')",
                      },
                    ],
                    attrs: {
                      slot: "footer",
                      space: "",
                      label: _vm.$ct("link.follows-crm-schedule"),
                    },
                    slot: "footer",
                    model: {
                      value: _vm.event.StartTimeIsLinkedToCrmTimeSheduled,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.event,
                          "StartTimeIsLinkedToCrmTimeSheduled",
                          $$v
                        )
                      },
                      expression: "event.StartTimeIsLinkedToCrmTimeSheduled",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }